import { render } from "./VerCliente.vue?vue&type=template&id=cce5d1dc"
import script from "./VerCliente.vue?vue&type=script&lang=js"
export * from "./VerCliente.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__